import React from 'react';
import { motion } from 'framer-motion';
import '../styles/ReviewTicker.css';

const reviews = [
  { id: "review-1", name: "Lauren", rating: 5, review: '"A great new series to sink your teeth into...Such a fun read with wit and humor..."' },
  { id: "review-2", name: "Winter", rating: 5, review: '"The writing draws you in from the beginning...definitely leaves you excited to see what happens next!"' },
  { id: "review-3", name: "Andrea", rating: 5, review: '"Amazing Novel...makes you feel like you\'re experiencing everything first hand."' },
  { id: "review-4", name: "Roxi", rating: 5, review: '"Fast paced and well written...I had a hard time putting my book down..."' },
  { id: "review-5", name: "Barry", rating: 5, review: '"Falkenberg delivered an innovative take on the genre...Character development is well done, layered..."' }
];

const StarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
  </svg>
);

const ReviewCard = ({ review }) => (
  <article className="ticker-card">
    <div className="ticker-card-rating">
      {Array.from({ length: review.rating }).map((_, i) => <StarIcon key={i} />)}
    </div>
    <p className="ticker-card-text">{review.review}</p>
    <footer className="ticker-card-name">
      — {review.name}
    </footer>
  </article>
);

const ReviewTicker = () => {
  // FIX: Duplicate the reviews only once for a seamless loop
  const duplicatedReviews = [...reviews, ...reviews];

  // This variant animates the track by half its width, creating the infinite effect
  const tickerVariants = {
    animate: {
      x: ['0%', '-50%'], // Animate from start to the halfway point
      transition: {
        x: {
          repeat: Infinity,
          repeatType: "loop",
          duration: 60, // A faster, more engaging duration
          ease: "linear",
        },
      },
    },
  };

  // Sleeker entrance animation for the whole section
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Animate children sequentially
      },
    },
  };

  // Animation for the title
  const titleVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  // Animation for the ticker itself
  const tickerContainerVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  return (
    <>

      <motion.div
        id="reviews"
        className="ticker-section"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {/* NEW: Professional Title */}
        <motion.h2 className="review-section-title" variants={titleVariants}>
          What Readers Are Saying
        </motion.h2>

        <motion.div className="ticker-container" variants={tickerContainerVariants}>
          <motion.div
            className="ticker-track"
            variants={tickerVariants}
            animate="animate"
          >
            {duplicatedReviews.map((review, index) => (
              <ReviewCard review={review} key={`${review.id}-${index}`} />
            ))}
          </motion.div>
        </motion.div>
      </motion.div>
     
    </>
  );
};

export default ReviewTicker;
